export interface ConfirmationStep {
  number: number;
  title: string;
  description: string;
}

export interface ConfirmationContent {
  title: string;
  subtitle: string;
  steps: ConfirmationStep[];
  emailNote: string;
}

export const signupConfirmationContent: Record<'free' | 'paid', ConfirmationContent> = {
  free: {
    title: "You're almost there!",
    subtitle: "Thank you for signing up for GreenLight",
    steps: [
      {
        number: 1,
        title: "Confirm your email",
        description: "Check your inbox and click the confirmation link"
      },
      {
        number: 2,
        title: "Create your first project",
        description: "Start streamlining your email reviews"
      }
    ],
    emailNote: "Didn't receive the email? Check your spam folder or contact support."
  },
  paid: {
    title: "You're almost there!",
    subtitle: "Thank you for choosing the {planName} plan",
    steps: [
      {
        number: 1,
        title: "Confirm your email",
        description: "Check your inbox and click the confirmation link"
      },
      {
        number: 2,
        title: "Complete payment",
        description: "Enter your payment details to activate your plan"
      },
      {
        number: 3,
        title: "Create your first project",
        description: "Start streamlining your email reviews"
      }
    ],
    emailNote: "Didn't receive the email? Check your spam folder or contact support."
  }
};

export const planDisplayNames: Record<string, string> = {
  starter: "Starter",
  pro: "Pro",
  unlimited: "Unlimited"
};
